import React from 'react';
import { Layers, Cpu, Target, Sparkles } from 'lucide-react';

const ExchangeIntegration = () => {
  const products = [
    {
      icon: Layers,
      name: 'Traain Engine',
      description: 'Create & manage Training'
    },
    {
      icon: Target,
      name: 'Traain Cadence',
      description: 'AI role-play & reinforcement'
    },
    {
      icon: Sparkles,
      name: 'Navigator AI™',
      description: 'Intelligent guidance & insights'
    }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Part of the <span className="text-cyan-400">Traain Platform</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-6 mb-12">
          {products.map((product, index) => {
            const Icon = product.icon;
            return (
              <div
                key={index}
                className="p-6 rounded-xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 hover:border-cyan-500/50 transition-all duration-300 text-center"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-7 h-7 text-cyan-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                <p className="text-gray-400">{product.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-xl text-cyan-400 font-semibold">
            One ecosystem. Continuous momentum.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ExchangeIntegration;
